import { Box, Card, CardContent, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface FormSectionProps {
  title: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function FormSection({ title, icon, action, children, sx }: FormSectionProps) {
  return (
    <Card variant="outlined" sx={{ mb: 1, ...sx }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent={action ? 'space-between' : undefined} mb={action ? 2 : 1}>
          <Box display="flex" alignItems="center">
            {icon && <Box sx={{ mr: 1, color: '#8600e1', display: 'flex' }}>{icon}</Box>}
            <Typography variant="h6">{title}</Typography>
          </Box>
          {action && <Box ml="10px">{action}</Box>}
        </Box>
        {children}
      </CardContent>
    </Card>
  );
}
